<div class="notification-menu">
  <div class="notification-menu__trigger" (click)="toggleDropdown($event)"
    [class.notification-menu__trigger--active]="isDropdownOpen">
    <img src="assets/icons/notifications.svg" alt="Notifications" class="green-filter">

    <!-- Notification badge -->
    @if (unreadCount > 0) {
      <span class="notification-menu__badge">
        {{ unreadCount > 99 ? '99+' : unreadCount }}
      </span>
    }

    <!-- Tooltip -->
    @if (!isDropdownOpen) {
      <span class="notification-menu__tooltip">
        {{ translateData?.notifications || 'Notifications' }}
      </span>
    }
  </div>

  <!-- Dropdown -->
  <div class="notification-menu__dropdown" [class.notification-menu__dropdown--open]="isDropdownOpen" #dropdownRef>

    <!-- Header -->
    <div class="notification-menu__header">
      <h3>{{ translateData?.notifications || 'Notifications' }}</h3>
      <button class="notification-menu__view-all" routerLink="/notifications" (click)="closeDropdown()">
        {{ translateData?.view_all || 'View All' }}
      </button>
    </div>

    <!-- Notifications list -->
    @if (recentNotifications.length > 0) {
      <div class="notification-menu__list">
        @for (notification of recentNotifications; track trackByNotificationId($index, notification)) {
          <div class="notification-menu__item"
            [class.notification-menu__item--unread]="!notification.done" (click)="markAsReadAndNavigate(notification)">
            <!-- Add an icon for the type/module? -->
            <!-- <div class="notification-menu__item-icon">
            <img [src]="getNotificationIcon(notification.type)" [alt]="notification.type">
          </div> -->
          <div class="notification-menu__item-content">
            <div class="notification-menu__item-title">
              {{ notification.module }}
            </div>
            <div class="notification-menu__item-description">
              {{ truncateText(notification.description, 80) }}
            </div>
            <div class="notification-menu__item-time">
              {{ formatTime(notification.datetime) }}
            </div>
          </div>
          @if (!notification.done) {
            <div class="notification-menu__item-status">
              <div class="notification-menu__unread-dot"></div>
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <div class="notification-menu__empty">
      <img src="assets/icons/no-notifications.svg" alt="No notifications" class="grey-filter">
      <p>{{ translateData?.no_notifications || 'No new notifications' }}</p>
    </div>
  }

  <!-- No notifications -->

  <!-- Footer -->
  @if (recentNotifications.length > 0) {
    <div class="notification-menu__footer">
      <button class="notification-menu__mark-all-read" (click)="markAllAsRead()" [disabled]="unreadCount === 0">
        {{ translateData?.mark_all_read || 'Mark all as read' }}
      </button>
    </div>
  }
</div>

<!-- Backdrop -->
@if (isDropdownOpen) {
  <div class="notification-menu__backdrop" (click)="closeDropdown()"></div>
}
</div>